<div class="edit-dialog-header" cdkFocusInitial tabindex="-1">
  <span>{{ 'Edit ' + title }}</span>
  <div class="header-actions">
    <div class="header-toggle-wrapper">
      <mat-slide-toggle
        aria-label="Show all fields"
        class="header-toggle"
        [(ngModel)]="showAll"
        [hideIcon]="true"
        (change)="onShowAllToggleChange()"
      ></mat-slide-toggle>
      <span class="header-toggle-label">{{ showAll ? 'Show' : 'Hide' }}</span>
    </div>
  </div>
  <button
    aria-label="Close"
    class="close-button"
    mat-button
    type="button"
    (click)="close()"
  >
    <img src="assets/close-icon.svg" alt="Close" />
  </button>
</div>

<mat-dialog-content
  class="edit-dialog-content"
  [class.debug-active]="showDebugToggle && debugFormsAdmin"
>
  <div class="fields-header row-divider">
    <span class="debug-type-col">elementType</span>
    <span class="field-heading">{{ title + ' Fields' }}</span>
    <span class="toggle-heading">Show/Hide</span>
  </div>

  @for (
    question of workingQuestions;
    track question.id;
    let questionIndex = $index
  ) {
    <div
      class="debug-question-wrapper"
      [class.row-divider]="questionIndex !== workingQuestions.length - 1"
    >
      <span class="debug-type-col">{{ question.elementType }}</span>
      <div class="debug-question-content">
        <!-- 'ALPHA', 'DATE', 'EMAIL', 'INPUT', 'NUMERIC', 'DROPDOWN' -->
        @if (basicInputTypes.has(question.elementType)) {
          <div
            class="field-row"
            [class.row-divider]="
              !question.potentialAnswers?.length &&
              questionIndex !== workingQuestions.length - 1
            "
          >
            <div class="field-column">
              <ng-container [ngTemplateOutlet]="basicInput"></ng-container>
            </div>

            <div class="toggle-column">
              @if (question.required) {
                <span class="required-label">Required on Form</span>
              } @else {
                <mat-slide-toggle [(ngModel)]="question.show">
                  {{ question.show ? 'Show' : 'Hide' }}
                </mat-slide-toggle>
              }
            </div>
          </div>

          @if (question.potentialAnswers?.length) {
            @for (answer of question.potentialAnswers; track answer.value) {
              <div
                class="field-row answer-row"
                [class.row-divider]="
                  $last && questionIndex !== workingQuestions.length - 1
                "
              >
                <div class="field-column">
                  <div class="field-row-inline">
                    <mat-form-field
                      appearance="outline"
                      class="field-input"
                      subscriptSizing="dynamic"
                    >
                      <input
                        matInput
                        aria-label="Answer label"
                        [(ngModel)]="answer.label"
                        [maxlength]="maxLengthPlaceHolder"
                      />
                      <span matSuffix class="character-counter"
                        >{{ answer.label?.length || 0 }}/{{
                          maxLengthPlaceHolder
                        }}</span
                      >
                    </mat-form-field>
                    @if (question.integrationValue?.length) {
                      <mat-form-field
                        appearance="outline"
                        class="field-input integration-value-field"
                        subscriptSizing="dynamic"
                      >
                        <input
                          matInput
                          aria-label="Integration value"
                          disabled
                          [value]="question.integrationValue![0].target ?? ''"
                        />
                      </mat-form-field>
                    }
                  </div>
                </div>
                <div class="toggle-column">
                  <mat-slide-toggle [(ngModel)]="answer.show">
                    {{ answer.show ? 'Show' : 'Hide' }}
                  </mat-slide-toggle>
                </div>
              </div>
            }
          }
        }

        <!-- 'CHECKBOX', 'MULTI_CHECKBOX', 'RADIO' -->
        @if (checkboxTypes.has(question.elementType)) {
          <ng-container [ngTemplateOutlet]="basicCheckbox"></ng-container>
        }

        <!-- 'TEXT', 'TITLE' -->
        @if (textTypes.has(question.elementType)) {
          <div
            class="field-row"
            [class.row-divider]="questionIndex !== workingQuestions.length - 1"
          >
            <div class="field-column">
              <span class="field-type-label">{{
                elementTypeLabels[question.elementType] || question.elementType
              }}</span>
              @if (question.elementType === 'TEXT') {
                <mat-form-field
                  appearance="outline"
                  class="field-input patient-prompt-field"
                  subscriptSizing="dynamic"
                >
                  <textarea
                    matInput
                    aria-label="Description"
                    rows="4"
                    [(ngModel)]="question.patientPrompt"
                    [maxlength]="maxLengthPatientPrompt"
                  ></textarea>
                  <span matSuffix class="character-counter"
                    >{{ question.patientPrompt?.length || 0 }}/{{
                      maxLengthPatientPrompt
                    }}</span
                  >
                </mat-form-field>
              } @else {
                <mat-form-field
                  appearance="outline"
                  class="field-input"
                  subscriptSizing="dynamic"
                >
                  <input
                    matInput
                    aria-label="Title"
                    [(ngModel)]="question.patientPrompt"
                    [maxlength]="maxLengthPlaceHolder"
                  />
                  <span matSuffix class="character-counter"
                    >{{ question.patientPrompt?.length || 0 }}/{{
                      maxLengthPlaceHolder
                    }}</span
                  >
                </mat-form-field>
              }
            </div>

            <div class="toggle-column">
              @if (question.required) {
                <span class="required-label">Required on Form</span>
              } @else {
                <mat-slide-toggle [(ngModel)]="question.show">
                  {{ question.show ? 'Show' : 'Hide' }}
                </mat-slide-toggle>
              }
            </div>
          </div>
        }

        <!-- 'IMAGE' -->
        @if (question.elementType === 'IMAGE') {
          <div
            class="field-row"
            [class.row-divider]="questionIndex !== workingQuestions.length - 1"
          >
            <div class="field-column">
              <span class="field-type-label">{{
                elementTypeLabels['IMAGE']
              }}</span>
              @if (question.potentialAnswers?.length) {
                <mat-form-field
                  appearance="outline"
                  class="field-input"
                  subscriptSizing="dynamic"
                >
                  <mat-select [(ngModel)]="question.selectedValue">
                    @for (
                      answer of question.potentialAnswers;
                      track answer.value
                    ) {
                      <mat-option [value]="answer.value">{{
                        answer.label
                      }}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              }
              @if (question.selectedValue) {
                <div class="image-preview">
                  <img
                    [src]="question.selectedValue"
                    [alt]="question.placeHolder || 'Selected image'"
                    class="image-preview-img"
                  />
                </div>
              } @else {
                <div class="image-preview image-placeholder">
                  <span>No image selected</span>
                </div>
              }
            </div>

            <div class="toggle-column">
              @if (question.required) {
                <span class="required-label">Required on Form</span>
              } @else {
                <mat-slide-toggle [(ngModel)]="question.show">
                  {{ question.show ? 'Show' : 'Hide' }}
                </mat-slide-toggle>
              }
            </div>
          </div>
        }

        <!-- 'PDF' -->
        @if (question.elementType === 'PDF') {
          <div
            class="field-row pdf-section"
            [class.row-divider]="questionIndex !== workingQuestions.length - 1"
            [class.incomplete-question]="
              questionCompletenessService.isQuestionIncomplete(question)
            "
          >
            <div class="field-column">
              <span class="field-type-label">{{
                question.placeHolder || elementTypeLabels['PDF']
              }}</span>
              <div class="pdf-upload-row">
                <input
                  type="file"
                  accept=".pdf"
                  style="display: none"
                  #pdfInput
                  (change)="onPdfFileSelected($event, question)"
                />
                <mat-form-field
                  appearance="outline"
                  class="field-input pdf-file-input"
                  subscriptSizing="dynamic"
                >
                  <input
                    matInput
                    aria-label="Selected file"
                    disabled
                    [value]="getPdfFileName(question)"
                    placeholder="Select File"
                  />
                </mat-form-field>
                <button
                  mat-stroked-button
                  type="button"
                  class="pdf-upload-button"
                  (click)="onUploadPdfClick(question, pdfInput)"
                >
                  Upload
                </button>
              </div>
              <span class="pdf-hint"
                >PDF files only. Maximum size:
                {{ getPdfMaxSizeMb(question) }}MB.</span
              >

              <span class="field-type-label pdf-button-label"
                >Button Label</span
              >
              <p class="pdf-info-message">
                {{
                  (question.placeHolder || '') +
                    ' file must be uploaded for the button to appear on the form.'
                }}
              </p>
              <mat-form-field
                appearance="outline"
                class="field-input"
                subscriptSizing="dynamic"
              >
                <input
                  matInput
                  aria-label="Button label"
                  [(ngModel)]="question.placeHolder"
                  [maxlength]="maxLengthPlaceHolder"
                />
                <span matSuffix class="character-counter"
                  >{{ question.placeHolder?.length || 0 }}/{{
                    maxLengthPlaceHolder
                  }}</span
                >
              </mat-form-field>
            </div>

            <div class="toggle-column">
              @if (question.required) {
                <span class="required-label">Required on Form</span>
              } @else {
                <mat-slide-toggle [(ngModel)]="question.show">
                  {{ question.show ? 'Show' : 'Hide' }}
                </mat-slide-toggle>
              }
            </div>

            @if (questionCompletenessService.isQuestionIncomplete(question)) {
              <conn-encompass-forms-error
                class="pdf-incomplete-error"
                [nonBlockingErrorConfig]="{
                  errorMessage:
                    questionCompletenessService.getIncompleteQuestionHint(
                      question
                    ) ?? genericIncompleteQuestionMessage,
                  isClosable: false,
                }"
              />
            }
          </div>
        }
        <ng-template #basicInput>
          @if (question.patientPrompt || question.patientPrompt === '') {
            <mat-form-field
              appearance="outline"
              class="field-input patient-prompt-field"
              subscriptSizing="dynamic"
            >
              <textarea
                matInput
                aria-label="Patient prompt"
                rows="4"
                [(ngModel)]="question.patientPrompt"
                [maxlength]="maxLengthPatientPrompt"
              ></textarea>
              <span matSuffix class="character-counter"
                >{{ question.patientPrompt?.length || 0 }}/{{
                  maxLengthPatientPrompt
                }}</span
              >
            </mat-form-field>
          }
          @if (question.integrationValue?.length) {
            <div class="field-row-inline">
              <mat-form-field
                appearance="outline"
                class="field-input"
                subscriptSizing="dynamic"
              >
                <input
                  matInput
                  aria-label="Placeholder"
                  [(ngModel)]="question.placeHolder"
                  [maxlength]="maxLengthPlaceHolder"
                />
                <span matSuffix class="character-counter"
                  >{{ question.placeHolder?.length || 0 }}/{{
                    maxLengthPlaceHolder
                  }}</span
                >
              </mat-form-field>
              <mat-form-field
                appearance="outline"
                class="field-input integration-value-field"
                subscriptSizing="dynamic"
              >
                <input
                  matInput
                  aria-label="Integration value"
                  disabled
                  [value]="question.integrationValue![0].target ?? ''"
                />
              </mat-form-field>
            </div>
          } @else {
            <mat-form-field
              appearance="outline"
              class="field-input"
              subscriptSizing="dynamic"
            >
              <input
                matInput
                aria-label="Placeholder"
                [(ngModel)]="question.placeHolder"
                [maxlength]="maxLengthPlaceHolder"
              />
              <span matSuffix class="character-counter"
                >{{ question.placeHolder?.length || 0 }}/{{
                  maxLengthPlaceHolder
                }}</span
              >
            </mat-form-field>
          }
        </ng-template>

        <ng-template #basicCheckbox>
          <div
            class="field-row"
            [class.row-divider]="questionIndex !== workingQuestions.length - 1"
          >
            @if (question?.patientPrompt || question?.patientPrompt === '') {
              <div class="field-column">
                <mat-form-field
                  appearance="outline"
                  class="field-input patient-prompt-field"
                  subscriptSizing="dynamic"
                >
                  <textarea
                    matInput
                    rows="4"
                    [(ngModel)]="question.patientPrompt"
                    [maxlength]="maxLengthPatientPrompt"
                  ></textarea>
                  <span matSuffix class="character-counter"
                    >{{ question.patientPrompt?.length || 0 }}/{{
                      maxLengthPatientPrompt
                    }}</span
                  >
                </mat-form-field>
              </div>
              <div class="toggle-column">
                @if (question.required) {
                  <span class="required-label">Required on Form</span>
                } @else {
                  <mat-slide-toggle [(ngModel)]="question.show"
                    >{{ question.show ? 'Show' : 'Hide' }}
                  </mat-slide-toggle>
                }
              </div>
            } @else if (
              (question?.placeHolder || question?.placeHolder === '') &&
              question.elementType !== 'MULTI_CHECKBOX'
            ) {
              <div class="field-column">
                <mat-form-field
                  appearance="outline"
                  class="field-input patient-prompt-field"
                  subscriptSizing="dynamic"
                >
                  <textarea
                    matInput
                    rows="4"
                    [(ngModel)]="question.placeHolder"
                    [maxlength]="maxLengthPatientPrompt"
                  ></textarea>
                  <span matSuffix class="character-counter"
                    >{{ question.placeHolder?.length || 0 }}/{{
                      maxLengthPatientPrompt
                    }}</span
                  >
                </mat-form-field>
              </div>
              <div class="toggle-column">
                @if (question.required) {
                  <span class="required-label">Required on Form</span>
                } @else {
                  <mat-slide-toggle [(ngModel)]="question.show"
                    >{{ question.show ? 'Show' : 'Hide' }}
                  </mat-slide-toggle>
                }
              </div>
            }

            @if (question?.potentialAnswers?.length) {
              @for (answer of question.potentialAnswers; track answer.value) {
                <div class="field-column">
                  <div class="answer-row field-row field-row-inline">
                    <mat-form-field
                      appearance="outline"
                      class="field-input"
                      subscriptSizing="dynamic"
                    >
                      <input
                        matInput
                        [(ngModel)]="answer.label"
                        [maxlength]="maxLengthPlaceHolder"
                      />
                      <span matSuffix class="character-counter"
                        >{{ answer.label?.length || 0 }}/{{
                          maxLengthPlaceHolder
                        }}</span
                      >
                    </mat-form-field>
                    @if (!!question?.integrationValue?.length) {
                      <mat-form-field
                        appearance="outline"
                        class="field-input integration-value-field"
                        subscriptSizing="dynamic"
                      >
                        <input
                          matInput
                          disabled
                          [value]="question.integrationValue![0].target ?? ''"
                        />
                      </mat-form-field>
                    }
                  </div>
                </div>
                <div class="toggle-column">
                  <mat-slide-toggle [(ngModel)]="answer.show"
                    >{{ answer.show ? 'Show' : 'Hide' }}
                  </mat-slide-toggle>
                </div>
              }
            }
          </div>
        </ng-template>
      </div>
      <!-- /debug-question-content -->
    </div>
    <!-- /debug-question-wrapper -->
  }
</mat-dialog-content>

<mat-dialog-actions>
  <div class="actions-left">
    <button mat-stroked-button type="button" (click)="close()">Cancel</button>
    <button mat-stroked-button type="button" (click)="reset()">Reset</button>
    @if (showDebugToggle) {
      <mat-slide-toggle
        class="debug-toggle"
        [(ngModel)]="debugFormsAdmin"
        [hideIcon]="true"
        (change)="onDebugToggleChange()"
        >Debug</mat-slide-toggle
      >
    }
  </div>
  <button
    class="save-button"
    color="primary"
    mat-flat-button
    type="button"
    (click)="save()"
  >
    Save
  </button>
</mat-dialog-actions>
